import React, { useState, useEffect } from 'react';
import { ReactComponent as CaretRight } from "img/arrows/caret-right.svg";

export type Card = {
    title: string;
    subtitle?: string;
    snippet: string;
    url: string;
};

export interface SearchResultsProps extends React.PropsWithChildren {
    cards: Card[];
};

const SearchResults: React.FC<SearchResultsProps> = ({ children, cards }) => {

    const [currentCards, setCurrentCards] = useState(cards);

    useEffect(() => {
        setCurrentCards(cards);
    }, [cards]);

    return (
        <div className="search-results-list">
            {currentCards.map((card, index) => (
                <div key={index} className="search-result-card">
                    {card.title && (
                        <h3 className="h4 search-result-card__title" dangerouslySetInnerHTML={{ __html: card.title }}></h3>
                    )}
                    {card.subtitle && <div className="search-result-card__subtitle">{card.subtitle}</div>}
                    {card.snippet && <div className="search-result-card__snippet" dangerouslySetInnerHTML={{ __html: card.snippet }} />}
                    {card.url && <a className="search-result-card__button btn-text-caret" href={card.url}>
                        <span>Learn More</span>
                        <CaretRight />
                    </a>}
                </div>
            ))}
            {children}
        </div>
    );
};

export default SearchResults;